var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no_user_container"},[_c('img',{attrs:{"src":require("@/assets/img/no_user.svg"),"alt":""}}),_vm._v(" 账号异常，请联系管理员！ ")])
}]

export { render, staticRenderFns }